/** @format */

import moment from 'jalali-moment';
import {
	isValidForeignersCode,
	isValidIranianNationalCode,
	toJalaliPickerValue,
} from '../../../../Shared/utils/helper';

export const required = (field) => {
	if (
		field?.value === undefined ||
		field?.value?.length === 0 ||
		field?.value == null
	) {
		return false;
	}
	return true;
};

export const mimes = (field) => {
	if (
		field?.value === undefined ||
		field?.value == null ||
		(field?.value.length > 0 && typeof field?.value == 'string')
	)
		return true;

	if (field?.validation?.mimes) {
		if (field?.validation?.mimes !== undefined) {
			let value = field?.value?.type?.replace(/^([a-zA-Z]+)\//, '');
			let mimes = field?.validation?.mimes?.split(',');
			let findMimes = mimes?.find((m) => m === value);
			if (!findMimes) {
				return false;
			}
		}
	}
	return true;
};

export const maxFileSize = (field) => {
	if (field.validation.max_file_size && field?.value?.size !== undefined) {
		let fileSize = parseInt(field.value.size) / 1000;
		if (fileSize > field.validation.max_file_size) {
			return false;
		}
	}
	return true;
};

export const maxLength = (field) => {
	if (
		field.validation.max_length &&
		field?.value?.length > field.validation.max_length
	) {
		return false;
	}

	return true;
};

export const persianString = (field) => {
	if (field.value?.length > 0) {
		let regex = /^[ آابپتثجچحخدذرزژسشصضطظعغفقکگلمنوهیئ\s]+$/;
		if (!regex.test(field.value)) return false;
	}
	return true;
};

export const mobile = (field) => {
	let regex = /^(0)(9\d{9})$/;
	if (!regex.test(field.value)) return false;
	return true;
};

export const dateFormat = (field) => {
	if (field.value?.length > 0) {
		let regex = /^\d{4}\/\d{1,2}\/\d{1,2}$/;
		if (!regex.test(field.value)) {
			return false;
		}
	}
	return true;
};
export const minEventDate = (field, minDate) => {
	if (field.value?.length > 0) {
		const jalaliValue = toJalaliPickerValue(field.value);
		if (
			moment(jalaliValue, 'jYYYY/jMM/jDD').isBefore(
				moment(minDate, 'YYYY-MM-DD HH:mm:ss'),
			)
		) {
			return false;
		}
	}

	return true;
};
export const maxEventDate = (field, maxDate) => {
	if (field.value?.length > 0) {
		const jalaliValue = toJalaliPickerValue(field.value);
		if (
			moment(jalaliValue, 'jYYYY/jMM/jDD').isAfter(
				moment(maxDate, 'YYYY-MM-DD HH:mm:ss'),
			)
		) {
			return false;
		}
	}

	return true;
};

export const isValidNatCode = (field) => {
	if (field.value?.length > 0) {
		if (field?.isForeigners !== undefined && field?.isForeigners) {
			if (!isValidForeignersCode(field?.value)) return false;
		} else {
			if (!isValidIranianNationalCode(field?.value)) return false;
		}
	}
	return true;
};
